import ActionButton from 'components/ActionButton';
import BackButton from 'components/BackButton';
import InfoModal from 'components/InfoModal';
import { Loading } from 'components/loading/Loading';
import ProcessCartModal from 'components/ProcessCartModal';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { fetchUserCartDetails, quoteCart } from 'services';
import { showError } from 'utils';
import BasicDetails from './basicDetails';
import styles from './index.module.scss';
import ListItems from './listItems';

const UserCartDetails = (props) => {
  const { cartId } = props.match.params;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({}) as any;
  const [isProcessCartModalOpen, setIsProcessCartModalOpen] = useState(false);
  const [isGoToOrderModalVisible, setIsGoToOrderModalVisible] = useState(false);

  const getShoppingListDetailsFn = async () => {
    setLoading(true);
    try {
      const response = await fetchUserCartDetails({ id: cartId });
      setData(JSON.parse(JSON.stringify(response)));
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const quoteCartFn = async (params) => {
    setLoading(true);
    try {
      const response = await quoteCart({  
        userId: data.user?.objectId, 
        selectedAddressId: _.get(data, 'selectedAddress.objectId', ''),
        selectedPaymentMethodId: _.get(data, 'paymentMethod.id', ''),
        ...params, 
      });
      setData(JSON.parse(JSON.stringify(response)));
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    getShoppingListDetailsFn();
  }, []);

  const toggleProcessCartModal = () => {
    setIsProcessCartModalOpen(!isProcessCartModalOpen);
  };

  const toggleGoToOrderModal = () => {
    setIsGoToOrderModalVisible(!isGoToOrderModalVisible);
  };

  const goToOrder = () => {
    props.history.push(`/orders/${data?.order?.objectId}`);
  };

  const onProcessCartSuccess = async () => {
    await getShoppingListDetailsFn(); 
    toggleGoToOrderModal();
  };

  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>User Cart Details</div>
      <div className={styles['header-buttons']}>
        <BackButton />
        <div className='d-flex'>
          {data.status === 'ACTIVE' && <ActionButton
            text={'Process Cart'}
            active={true}
            isLoading={false}
            onClick={toggleProcessCartModal}
          />}
          {isProcessCartModalOpen && <ProcessCartModal
            cart={data}
            toggleModal={toggleProcessCartModal}
            onSuccess={onProcessCartSuccess}
            userId={data.user?.objectId}
          />}
          <ActionButton
            text={'Quote Cart'}
            active={true}
            isLoading={false}
            onClick={quoteCartFn}
            customClass='ml-5'
          />
        </div>
      </div>
    </div>
  );
      
  const getCartItems = () => {
    if(!!data?.items){
      return Object.keys(data?.items)?.map((item)=>{return{ ...data?.items[item] }});
    } else {
      return [];
    }
  };

  return(
    <div id={'main-container'} className={`${styles['main-container']}`}>
      {getHeader()}
      {loading ? <Loading /> : 
        <>
          <BasicDetails details={data} quoteCartFn={quoteCartFn} />
          <ListItems 
            items={getCartItems()} 
            listId={cartId} 
            getCart={getShoppingListDetailsFn}
            userId={data.user?.objectId}
          />
          {isGoToOrderModalVisible && <InfoModal
            title='Cart processed successfully'
            message='The cart has been processed successfully and order is created.'
            cancellable
            toggleModal={toggleGoToOrderModal}
            primaryButtonText={'Go to Order'}
            primaryButtonOnClick={goToOrder}
            secondaryButtonText="Close"
            secondaryButtonOnClick={toggleGoToOrderModal}
          />}
        </>
      }
    </div>
  );
};

export { UserCartDetails };